
class CapViewVendorList {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return false
  }
}

function key() {
  return 'view_vendor_list'
}

function create(config) {
  return new CapViewVendorList(config)
}

export default {
  key,
  create,
}
